import { render, staticRenderFns } from "./ScreensAndMenus.vue?vue&type=template&id=53122892&scoped=true&"
import script from "./ScreensAndMenus.vue?vue&type=script&lang=js&"
export * from "./ScreensAndMenus.vue?vue&type=script&lang=js&"
import style0 from "./ScreensAndMenus.vue?vue&type=style&index=0&id=53122892&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53122892",
  null
  
)

export default component.exports